export * from 'vue-toastification-original'
export { default } from 'vue-toastification-original'

import useGlobalToast from '@/composables/useGlobalToast'
export const useToast = useGlobalToast
